import React from 'react';
import DownloadContainer from 'containers/DownloadContainer';
import Table, { THead, TBody, Tr, Th, Td } from 'components/UIKit/Table';
import Icon from 'components/UIKit/Icon/Icon';

export default function DataValidationTable({
  report
}) {
  return (
    <Table>
      <THead>
        <Tr>
          <Th>Program</Th>
          <Th>Project</Th>
          <Th>dbGaP Study ID</Th>
          <Th>File Size Fail</Th>
          <Th>md5sum Fail</Th>
          <Th>File Format Fail</Th>
          <Th>Files Validated</Th>
        </Tr>
      </THead>
      <TBody>
        { report.length > 0 && report.map((r, i) => (
        <Tr key={ i }>
          <Td>{ r.program }</Td>
          <Td>{ r.project }</Td>
          <Td>{ r.dbgap_accession_number }</Td>
          <Td>{ r.fileSizeFail }</Td>
          <Td>{ r.md5sumFail }</Td>
          <Td>{ r.fileFormatFail }</Td>
          <Td>{ r.filesValidated }</Td>
        </Tr>
        ))}
      </TBody>
    </Table>
  );
}
